export const QUICK_SEARCH = "quick.search.bar.placeholder";

export const QUICK_SEARCH_BOT_STRIP_DEFAULT = "quick.search.bot_strip.default";
export const QUICK_SEARCH_BOT_STRIP_WITH_QUERY = "quick.search.bot_strip.with_query";
